import React from "react";
import { withTranslation } from 'react-i18next';
import { KycAddId } from "./kycAddIdProof";
  
class KycAddIdParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
    
        }
      }
  render() {
    return <KycAddId {...this?.props}/> ;
  }
}

export default withTranslation('kyc')(KycAddIdParent);
